const Check = ({size, color}: {size: number, color: string}) => {
    return(
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM17.565 9.56588C17.8774 9.25346 17.8774 8.74693 17.565 8.43451C17.2525 8.12209 16.746 8.12209 16.4336 8.43451L9.99926 14.8688L7.5649 12.4345C7.25248 12.1221 6.74595 12.1221 6.43353 12.4345C6.12111 12.7469 6.12111 13.2535 6.43354 13.5659L9.43358 16.5659C9.746 16.8783 10.2525 16.8783 10.5649 16.5659L17.565 9.56588Z" fill={color}/>
        </svg>
    );
}

export default Check;